import { HttpClient } from '@angular/common/http';
import { normalizeApiBaseUrl } from 'src/app/shared/utils/api-base-url';
import { JSON_HTTP_OPTIONS } from 'src/app/shared/utils/json-http-options';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private router: Router, private http: HttpClient) { }
GetCompanyByID(): Observable<any> {
    const body = {};
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/company-by-id`, body, JSON_HTTP_OPTIONS);
  }

  GetStates(): Observable<any> {
    const body = {};
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/states-for-new-company`, body, JSON_HTTP_OPTIONS);
  }

  GetAllCompanies(data): Observable<any> {
    const body = data;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/all-companies`, body, JSON_HTTP_OPTIONS);
  }

  GetCompanyByCompanyID(): Observable<any> {
    const body = {};
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/company-by-company-id`, body, JSON_HTTP_OPTIONS);
  }

  InsertCompany(data): Observable<any> {
    const body = data;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/company`, body, JSON_HTTP_OPTIONS);
  }

  UpdateCompany(data): Observable<any> {
    const body = data;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/company`, body, JSON_HTTP_OPTIONS);
  }

  ResetPasswordForCompany(data): Observable<any> {
    const body = data;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/reset-password-for-company`, body, JSON_HTTP_OPTIONS);
  }

  DeleteCompany(data): Observable<any> {
    const body = data;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/company`, body, JSON_HTTP_OPTIONS);
  }

  DeleteCompanyByFY(data): Observable<any> {
    const body = data;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Company/company-by-fy`, body, JSON_HTTP_OPTIONS);
  }

  getFinancialYearFromDate(financialYear: string): string {
    return financialYear?.trim() || '';
  }

  getFinancialYearToDate(financialYear: string): string {
    const fromDate = this.getFinancialYearFromDate(financialYear);
    if (!fromDate) {
      return '';
    }

    const parts = fromDate.split(/[\/\-\.]/);
    if (parts.length !== 3) {
      return fromDate;
    }

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return fromDate;
    }

    const endDate = new Date(year + 1, month - 1, day);
    endDate.setDate(endDate.getDate() - 1);

    const dd = String(endDate.getDate()).padStart(2, '0');
    const mm = String(endDate.getMonth() + 1).padStart(2, '0');
    const yyyy = endDate.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
}
